import VariantsApi from '../../apis/Variants';

export default {
    namespaced: true,
    state: {
        variants: [],
        variant_response: null,
        variant_options: [],
        variants_header: [],
        variants_rows: [],
        row_selected: {}
    },
    mutations: {
        set_variants (state, data) {
            state.variants = data;
        },
        set_variant_response (state, value) {
            state.variant_response = value;
        },
        set_variant_options (state, data) {
            state.variant_options = data;
        },
        set_variants_header (state, data) {
            state.variants_header = data;
        },
        set_variants_rows (state, data) {
            state.variants_rows = data;
        },
        set_row_selected (state, data) {
            state.row_selected = data;
        },
        add_variant_row (state, data) {
            state.variants_rows.push(data);
        },
        replace_variant_row (state, data) {
            state.variants_rows.splice(data.index, 1, data.row);
        },
        delete_variant_row (state, index) {
            state.variants_rows.splice(index, 1);
        }
    },
    actions: {
        setVariantsHeader ({commit}, data) {
            commit('set_variants_header', data);
        },
        setVariantsRows ({commit}, data) {
            commit('set_variants_rows', data);
        },
        setRowSelected ({commit}, data) {
            commit('set_row_selected', data);
        },
        addVariantRow ({commit}, data) {
            commit('add_variant_row', data);
        },
        replaceVariantRow ({commit}, data) {
            commit('replace_variant_row', data);
        },
        deleteVariantRow ({commit}, index) {
            commit('delete_variant_row', index);
        },
        async getVariants({commit}, filters) {
            commit('set_variant_response', null);
            return await VariantsApi.get_all(filters)
                .then( response => {
                    commit('set_variants', response.data)
                })
                .catch( error => {
                    commit('set_variant_response', 'error');
                })
        },
        async getVariantOptions({commit}, filters) {
            commit('set_variant_options', []);
            return await VariantsApi.get_Options(filters)
                .then( response => {
                    commit('set_variant_options', response.data)
                });
        },
        async store({commit, dispatch}, variant) {
            commit('set_variant_response', null);
            return await VariantsApi.store(variant)
                .then( response => {
                    commit('set_variant_response', 'success');
                    dispatch('getVariants');
                })
                .catch( error => {
                    commit('set_variant_response', 'error');
                })
        },
        async update({commit, dispatch}, variant) {
            commit('set_variant_response', null);
            return await VariantsApi.update(variant)
                .then( response => {
                    commit('set_variant_response', 'success');
                    dispatch('getVariants')
                })
                .catch( error => {
                    commit('set_variant_response', 'error');
                })
        },
        async change_status({commit, dispatch}, variant) {
            commit('set_variant_response', null);
            return await VariantsApi.change_status(variant)
                .then( response => {
                    commit('set_variant_response', 'success');
                    dispatch('getVariants')
                })
                .catch( error => {
                    commit('set_variant_response', null);
                })
        },
    }
}